import {
  InvoiceID,
  InvoiceNanoID,
  InvoiceUUID,
  UpdateViewSettingsInvoiceCacheKeys,
  UpdateViewSettingsInvoiceGqlQuery
} from '../../invoicesTypes';

import { useCacheUpdateQuery } from '../../../common/reactQuery/hooks/useCacheUpdateQuery';

interface CacheUpdateViewSettingsInvoiceOptions {
  query: UpdateViewSettingsInvoiceGqlQuery;
  cacheKeys?: UpdateViewSettingsInvoiceCacheKeys;
}

export interface CacheUpdateViewSettingsInvoiceResponse {
  updateViewSettingsInvoice: {
    statusCode: number;
    message: string;
  };
}

export interface CacheUpdateViewSettingsInvoiceInput {
  uuid: InvoiceID | InvoiceUUID | InvoiceNanoID;
  viewSettings: Record<string, unknown>;
}

// TODO:
// Add error type for nest gql mutation response
export type CacheUpdateViewSettingsInvoiceError = null;

const action = 'invoiceUpdateViewSettings';

function useCacheUpdateViewSettingsInvoice<
  CacheUpdateViewSettingsInvoiceRecordType = unknown
>({ query, cacheKeys }: CacheUpdateViewSettingsInvoiceOptions) {
  const {
    updateCacheQuery,
    updateCacheQueryData,
    updateCacheQueryError,
    updateCacheQueryErrorMessage,
    updateCacheQueryLoading,
    updateCacheQueryReset
  } = useCacheUpdateQuery<
    CacheUpdateViewSettingsInvoiceInput,
    CacheUpdateViewSettingsInvoiceResponse,
    CacheUpdateViewSettingsInvoiceError,
    CacheUpdateViewSettingsInvoiceRecordType
  >({ action, query, cacheKeys });

  return {
    updateViewSettingsInvoice: updateCacheQuery,
    updateViewSettingsInvoiceData: updateCacheQueryData,
    updateViewSettingsInvoiceError: updateCacheQueryError,
    updateViewSettingsInvoiceErrorMessage: updateCacheQueryErrorMessage,
    updateViewSettingsInvoiceLoading: updateCacheQueryLoading,
    updateViewSettingsInvoiceReset: updateCacheQueryReset
  };
}

export default useCacheUpdateViewSettingsInvoice;
